import img from "../../asset/newRectangle 4172.png";

export default function AboutUs1() {
  return (
    <section className="min-h-screen flex items-center justify-center px-6 sm:px-12 md:px-16 lg:px-24 xl:px-32 py-12 sm:py-16 md:py-20 bg-[#F4F0E3]">
      <div className="max-w-[1920px] w-full grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-20 items-center">
        
        {/* Left Content Section */}
        <div className="space-y-6 md:space-y-8">
          <div className="relative">
            <h2 className="text-[#0A476C] font-inter text-xs sm:text-sm md:text-base font-semibold uppercase mb-1">
              Helping victims of
            </h2>

            <h1 className="text-[#0A476C] font-futura font-bold text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-[60px] 2xl:text-[70px] leading-snug mb-2">
              Win More Vehicle Accident Claims
            </h1>

            {/* Full-width orange underline */}
            <div className="w-full h-2 bg-[#FC821F] rounded"></div>
          </div>

          <p className="text-[#0A476C] font-avenir text-xs sm:text-sm md:text-base lg:text-lg max-w-lg leading-relaxed">
            We specialize in motor vehicle accident lead generation because we know these cases are among the
            most valuable for law firms. From car and truck crashes to rideshare and pedestrian accidents, we
            connect your firm with the right clients at the right time. Partner with Belief Marketing Enterprises
            and build a growth engine that delivers consistent, qualified cases.
          </p>

          {/* Optional buttons */}
          {/* <div className="flex flex-col sm:flex-row gap-4">
            <button className="px-8 py-4 bg-[#EBFF02] text-[#0A476C] font-inter font-bold text-sm sm:text-base md:text-lg rounded-lg transition-colors duration-200 hover:bg-yellow-300">
              About us
            </button>
            <button className="px-8 py-4 bg-[#0A476C] text-[#EBFF02] font-inter font-bold text-sm sm:text-base md:text-lg rounded-lg transition-colors duration-200 hover:bg-blue-700">
              Get Legal Help
            </button>
          </div> */}
        </div>

        {/* Right Image Section */}
        <div className="relative w-full flex justify-center">
          <img
            src={img}
            alt="Diverse group of survivors and community members standing together"
            className="w-full max-w-[700px] lg:max-w-full h-auto rounded-lg object-cover"
          />
        </div>

      </div>
    </section>
  );
}
